module.exports = __webpack_public_path__ + "img/032-drink.748b713e.png";